import axios from 'axios';
import mock from '@/mock/api';
import store from '@/store/index.js'
import Router from '@/router/index.js'
import { paths, } from '@/common/const'
/***************************************************************************************************************************** */
// axios 接続設定 
/***************************************************************************************************************************** */
const api_url = process.env.VUE_APP_API_URL

const auth_url = process.env.VUE_APP_AUTH_URL


export const auth_token_login_user = axios.create({
  baseURL: auth_url,
})

auth_token_login_user.interceptors.request.use(config => {
  config.headers['X-AUTH-TOKEN'] = "Bearer " + store.getters.getToken
  return config
})

export const client_addr = axios.create({
  baseURL: 'https://zipcloud.ibsnet.co.jp/api',
})

export const client = axios.create({
  baseURL: 'https://test.com/url/of/your/api',
})

/**
 * javaセッションに認証情報がない場合403エラーになる
 */
export const client_auth = axios.create({
  baseURL: auth_url,
  headers: {
    // 'Content-Type': 'application/json;charset=utf-8',
    'Access-Control-Allow-Origin': 'http://localhost:8080/',
  },
  // emulateJSON: true,
  withCredentials: true,
})

client_auth.interceptors.request.use(config => {
  config.headers['X-AUTH-TOKEN'] = "Bearer " + store.getters.getToken
  return config
})

let isErrorStatus = function (error) {
  // 失敗時の処理0
  switch (error.response?.status) {
    case 401:
    case 403:
      //ログイン画面に遷移
      // 例外処理 
      Router.push(paths.login);
      break;
    case 406:
      alert("登録・更新に失敗したためトップ画面に遷移します。")
      Router.push(paths.top);
      break;
    case 500:
      console.error(error);
      Router.push(paths.error);
      break;
    default:
      throw error
  }
}
client_auth.interceptors.response.use(
  response => {
    store.dispatch("saveToken", response.headers['x-auth-token'])
    return response
  },
  error => {
    isErrorStatus(error)
    return error
  }
  )

export const api_user = axios.create({
  baseURL: api_url,
})
api_user.interceptors.request.use(config => {
  config.headers['X-AUTH-TOKEN'] = "Bearer " + store.getters.getToken
  return config
})
api_user.interceptors.response.use(
  response => {
    store.dispatch("saveToken", response.headers['x-auth-token'])
    return response
  },
  error => {
    isErrorStatus(error)
  }
)// モック起動
if (JSON.parse(process.env.VUE_APP_USE_MOCK)) {
  mock.run(client)
  mock.run(client_auth)
  mock.run(api_user)
}

export default {

  /***************************************************************************************************************************** */
  // 外部呼出し処理処理 
  /***************************************************************************************************************************** */


  /**
   * 郵便番号住所検索API
   * 結果はPromiseを返してハンドリングする
   * @param {String} zip 郵便番号
   */
  getAddress(zip) {
    return client_addr.get('/search', { params: { zipcode: zip } });
  },

  /***************************************************************************************************************************** */
  /***************************************************************************************************************************** */
  // 画面機能共通処理
  /***************************************************************************************************************************** */

  /**
   * マスタ取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params categoryとcodeプロパティを持つオブジェクト
   * @returns 
   */
  getMstValue(params) {
    return api_user.get('/code-mst', params);
  },
  /**
   * 利用可能日付の取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   * @returns 
   */
   getAvailableDate(params) {
    return api_user.get('/available-date', params);
  },
  /***************************************************************************************************************************** */
  // 画面機能個別設定 (アカウントAPI)
  /***************************************************************************************************************************** */
  /**
  * 認証API
  * 結果はPromiseを返してハンドリングする
  * @param {Object} params パラメータ
  */

  login(params) {
    // return client_auth.post('/login', params, {withCredentials: true});
    return client_auth.post('/login', params)
  },
  /**
   * ログインユーザ情報取得API
   * 結果はPromiseを返してハンドリングする
   * @param {String} userId ユーザID
   */
  getLoginUser(userId) {
    return client_auth.get('/login-user', { params: { userId: userId } });
  },
  /**
   * ログイン確認API
   */
  isLogin() {
    return client_auth.get('/isLogin')
      .catch(() => {
        alert("ログインしてください")
        Router.push('/login')
      })
  },
  /**
   * パスワード更新API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   */
  putPassword(params) {
    return client_auth.put('/login-user/', params);
  },
  /**
   * 担当者リスト取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params パラメータ
   */
  getEmployeeList(params) {
    return client_auth.get('/account/list', params);
  },
  /**   
   * 担当者情報取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params パラメータ
   */
  getEmployee(id, params) {
    return client_auth.get('/account/' + id, params);
  },
  /**
   * 担当者情報追加API
   * @param {Object} params パラメータ
   */
  addEmployee(params) {
    return client_auth.post('/account', params)
  },
  /**
   * 担当者情報更新API
   * @param {Object} params パラメータ
   */
  updateEmployee(id, params) {
    return client_auth.put('/account/' + id, params)
  },
  /**
   * 担当者情報削除API
   * @param {Object} params パラメータ
   */
  deleteEmployee(id, params) {
    return client_auth.delete('/account/' + id, { data: params })
  },

  postValidationEmployee(params) {
    return client_auth.post('/account/validation', params)
  },

  /***************************************************************************************************************************** */
  // 画面機能個別設定 (共通API)
  /***************************************************************************************************************************** */

  /**
   * お知らせリスト取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params パラメータ
   */
  getInfoList(params) {
    return api_user.get('/infomation/list', params);
  },

  /**   
   * 企業情報詳細API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params パラメータ
   */
   getDetailInfoCompany(id) {
    return api_user.get('/corporate-customer', { params: { id: id } });
  },

    /**   
   * 企業情報更新API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params パラメータ
   */
     putUpdateCompany(params) {
      return api_user.put('/corporate-customer',params);
    },

  
  /**   
  * 法人顧客バリデーションPI
  * 結果はPromiseを返してハンドリングする
  * @param {Object} params パラメータ
  */
  postValidationCompany(params) {
    return api_user.post('/corporate-customer/validation', params);
  },
  /**
   * 契約企業情報リスト取得API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   */
  getCompanyInfoList(params) {
    return api_user.get('/corporate-customer/list', params);
  },
  /**
   * 回線申込API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   */
  postLineApplicationInfo(params) {
    return api_user.post('/line-contract/', params);
  },
  /**
   * 回線申込バリデーションAPI
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   */
  postValidateLineApplicationInfo(params) {
    return api_user.post('/line-contract/validation/newline', params);
  },
  /**
   * 申込情報リスト取得API
   * 結果はPromiseを返してハンドリングする
   */
  getRegistrationInfoList(params) {
    return api_user.get('/line-contract/list', params);
  },
  /**
   * 申込情報詳細取得API
   * 結果はPromiseを返してハンドリングする
   * @param {string} number 回線ID
   */
  getRegistrationInfoDetail(number) {
    return api_user.get('/line-contract/' + number);
  },
  /**
   * オプション申込API
   * 結果はPromiseを返してハンドリングする
   * @param {String} id 回線ID
   * @param {object} params オプション申込パラメータ
   */
  postOptionApplication(id, params) {
    return api_user.post(`/line-contract/${id}/option`, params)
  },
  /**
   * オプション申込バリデーションAPI
   * 結果はPromiseを返してハンドリングする
   * @param {object} params オプション申込パラメータ
   */
  postValidateOptionApplication(params) {
    return api_user.post(`/line-contract/validation/option`, params)
  },
  /**
   * 回線解約申込API
   * 結果はPromiseを返してハンドリングする
   * @param {object} params 
   */
  postCancelLine(id, params) {
    return api_user.post(`/line-contract/${id}/termination`, params)
  },
  /**
   * 回線解約バリデーションAPI
   * 結果はPromiseを返してハンドリングする
   * @param {object} params 
   */
  postValidateCancelLine(params) {
    return api_user.post('/line-contract/validation/termination', params)
  },
  /**
   * 解約受付後請求明細リストAPI
   * 結果はPromiseを返してハンドリングする
   * @param {String} id 回線ID
   * @param {object} params パラメータ
   */
  getBillDetailList(id, params) {
    return api_user.get(`/billing/${id}`, params);
  },
  /**
   * 事業者精算情報リスト取得API
   * 結果はPromiseを返してハンドリングする
   */
  getBusinessSettlementInfo(params) {
    return api_user.get('/settlement/list', params);
  },
  /**
   * 事業者精算情報リスト(csv形式)取得API
   * 結果はPromiseを返してハンドリングする
   */
  downloadSettlement(yyyymm) {
    return api_user.get('/settlement/' + yyyymm + '/download');
  },
  /**
   * 利用料金情報リスト取得
   * 結果はPromiseを返してハンドリングする
   */
  getUsageFeeList(){
    return api_user.get('/usage-fee/list');
  },
  /**
   *  利用料金情報リスト(csv形式)取得API
   *  結果はPromiseを返してハンドリングする
   */
  downloadUsageFeeList(){
    return api_user.get('/usage-fee/download');
  },
  /**
   * 利用明細情報リスト取得
   * 結果はPromiseを返してハンドリングする
   */
  getUsageFeeDetailList(yyyymm){
    return api_user.get('/usage-fee/' + yyyymm + '/list');
  },
  /**
   *  利用明細情報リスト(csv形式)取得API
   *  結果はPromiseを返してハンドリングする
   */
   downloadUsageFeeDetailList(yyyymm){
    return api_user.get('/usage-fee/' + yyyymm + '/download');
  },
  /**
   * 利用明細情報リスト取得(回線IDに紐づいた情報)
   * 結果はPromiseを返してハンドリングする
   * @param {String} id 
   */
  getUsageFeeLineId(id){
    return api_user.get(`/usage-fee/${id}`);
  },
  /**
   * メール送信API
   * 結果はPromiseを返してハンドリングする
   * @param {Object} params 
   */
  postSendMail(params) {
    return client_auth.post('/reset-password', params);
  },
  /**
* メールアドレス照会API
* 結果はPromiseを返してハンドリングする
* @param {Object} params 
*/
  getSendMail(params) {
    return client_auth.get('/reset-password', { params: { hash: params.id } });
  },
  /**
  * メールアドレス取得API
  * 結果はPromiseを返してハンドリングする
  * @param {Object} id 
  */
  getMailAddress(id) {
    return this.auth_access_get('/mailAddress', { params: { id: id } });
  },
  /**
 * メールアドレス初期化API
 * 結果はPromiseを返してハンドリングする
 * @param {Object} params 
 */
  putSendMail(params) {
    return client_auth.put('/reset-password', params);
  },
  /**
  * パスワード初期化API
  * 結果はPromiseを返してハンドリングする
  * @param {Object} id 
  */
  postMailAddress(id) {
    return this.auth_access_post('/mailAddress', id);
  },

}